
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

import { RegistrarCargaInventarioComponent } from './registrar-carga-inventario-component';
import { RegistrarCargaInventarioRoutingModule } from './registrar-carga-inventario-routing.module';
import { TablaInventarioExcelComponent } from './tabla-inventario-excel.component';

@NgModule({
    declarations: [RegistrarCargaInventarioComponent, TablaInventarioExcelComponent,],
    imports: [
        SharedModule,
        CommonModule,
        RegistrarCargaInventarioRoutingModule
    ],
    exports: [RegistrarCargaInventarioComponent, TablaInventarioExcelComponent]
})
export class RegistrarCargaIntentarioModule { }
